import Vue from 'vue'
import VueRouter from 'vue-router'

// devs
// import DashboardSvg from '@/components/charts/dev/DashboardSvg.vue'
// import ColorsSystem from '@/views/dev/ColorsSystem.vue'
// import Drafts from '@/views/dev/Drafts.vue'

// import PublicIndex from '@/views/PublicIndex.vue'

// import Dashboard from '@/views/Dashboard.vue'

// import Procedures from '@/views/procedures/Procedures.vue'
// import ProcedureCard from '@/views/procedures/ProcedureCard.vue'

// import Claims from '@/views/claims/Claims.vue'
// import ClaimCard from '@/views/claims/ClaimCard.vue'
// import ClaimsJournal from '@/views/claims/ClaimsJournal.vue'

// import Contracts from '@/views/contracts/Contracts.vue'
// import ContractsStats from '@/views/contracts/ContractsStats.vue'
// import ContractCard from '@/views/contracts/ContractCard.vue'
// import ContractsJournal from '@/views/contracts/ContractsJournal.vue'
// import ContractTemplates from '@/views/document_templates/ContractTemplates.vue'
// import ContractDocument from '@/views/document_templates/ContractDocument.vue'

// import Orders from '@/views/orders/Orders.vue'
// import OrdersStats from '@/views/orders/OrdersStats.vue'
// import OrderCard from '@/views/orders/OrderCard.vue'
// import OrdersJournal from '@/views/orders/OrdersJournal.vue'

// import Reports from '@/views/Reports.vue'
// import Settings from '@/views/Settings.vue'

import store from '@/store'
import { availableRouterFeatures } from '@/utils/featureset.js'
import { queryPage } from '@/utils/router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/dashboard',
    name: 'dashboard',
    // component: Dashboard,
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue'),
    meta: { requiresAuth: true, title: 'Дашборд', bg: 'settings/setSecondaryBG' },
    feature: 'dashboard'
  },
  {
    path: '/procedures',
    name: 'procedures',
    // component: Procedures,
    component: () => import(/* webpackChunkName: "procedures" */ '../views/procedures/Procedures.vue'),
    props: route => ({ page: queryPage(route.query) }),
    meta: { requiresAuth: true, title: 'Торги', bg: 'settings/setSecondaryBG' },
    feature: 'procedure'
  },
  {
    path: '/procedures/:id',
    name: 'procedure_card',
    // component: ProcedureCard,
    component: () => import(/* webpackChunkName: "procedure_card" */ '../views/procedures/ProcedureCard.vue'),
    props: (route) => ({ id: +route.params.id }),
    meta: { requiresAuth: true, title: '', bg: 'settings/setSecondaryBG' },
    feature: 'procedure'
  },
  {
    path: '/claims',
    name: 'claims',
    // component: Claims,
    component: () => import(/* webpackChunkName: "claims" */ '../views/claims/Claims.vue'),
    props: route => ({ page: queryPage(route.query) }),
    meta: { requiresAuth: true, title: 'Заявки', bg: 'settings/setSecondaryBG' },
    feature: 'claim'
  },
  {
    path: '/claims/:id',
    name: 'claim_card',
    // component: ClaimCard,
    component: () => import(/* webpackChunkName: "claim_card" */ '../views/claims/ClaimCard.vue'),
    props: (route) => ({ id: +route.params.id }),
    meta: { requiresAuth: true, title: '', bg: 'settings/setSecondaryBG' },
    feature: 'claim'
  },
  {
    path: '/claims_journal',
    name: 'claims_journal',
    // component: ClaimsJournal,
    component: () => import(/* webpackChunkName: "claims_journal" */ '../views/claims/ClaimsJournal.vue'),
    meta: { requiresAuth: true, title: 'Журнал статусов заявок', bg: 'settings/setSecondaryBG' },
    feature: 'claim.journal'
  },
  {
    path: '/contracts',
    name: 'contracts',
    // component: Contracts,
    component: () => import(/* webpackChunkName: "contracts" */ '../views/contracts/Contracts.vue'),
    props: route => ({ params: route.query }),
    meta: { requiresAuth: true, title: 'Договоры', bg: 'settings/setSecondaryBG' },
    feature: 'contract'
  },
  {
    path: '/contracts/journal',
    name: 'contracts_journal',
    // component: ContractsJournal,
    component: () => import(/* webpackChunkName: "contracts_journal" */ '../views/contracts/ContractsJournal.vue'),
    props: route => ({ params: route.query }),
    meta: { requiresAuth: true, title: 'Журнал статусов договоров', bg: 'settings/setSecondaryBG' },
    feature: 'contract.journal'
  },
  {
    path: '/contracts/:id',
    name: 'contract_card',
    // component: ContractCard,
    component: () => import(/* webpackChunkName: "contract_card" */ '../views/contracts/ContractCard.vue'),
    props: (route) => ({ id: +route.params.id, params: route.query }),
    meta: { requiresAuth: true, title: '', bg: 'settings/setSecondaryBG' },
    feature: 'contract'
  },
  {
    path: '/contracts_stats',
    name: 'contracts_stats',
    // component: ContractsStats,
    component: () => import(/* webpackChunkName: "contracts_stats" */ '../views/contracts/ContractsStats.vue'),
    meta: { requiresAuth: true, title: '', bg: 'settings/setSecondaryBG' },
    feature: 'contract.stats'
  },
  {
    path: '/document_templates',
    name: 'document_templates',
    // component: ContractTemplates,
    component: () => import(/* webpackChunkName: "document_templates" */ '../views/document_templates/ContractTemplates.vue'),
    props: route => ({ page: queryPage(route.query) }),
    meta: { requiresAuth: true, title: 'Шаблоны документов', bg: 'settings/setSecondaryBG' },
    feature: 'contract.template'
  },
  {
    path: '/document_templates/:id',
    name: 'document_template',
    component: () => import(/* webpackChunkName: "document_template_form" */ '../views/document_templates/TemplateForm.vue'),
    props: (route) => ({ id: +route.params.id }),
    meta: { requiresAuth: true, title: '', bg: 'settings/setPrimaryBG' },
    feature: 'contract.template'
  },
  {
    path: '/contracts/:contract_id/document/:template_id',
    name: 'render_document',
    // component: ContractDocument,
    component: () => import(/* webpackChunkName: "render_document" */ '../views/document_templates/ContractDocument.vue'),
    props: true,
    meta: { requiresAuth: true, title: '', bg: 'settings/setPrimaryBG' },
    feature: 'contract.template'
  },
  {
    path: '/orders',
    name: 'orders',
    // component: Orders,
    component: () => import(/* webpackChunkName: "orders" */ '../views/orders/Orders.vue'),
    props: route => ({ params: route.query }),
    meta: { requiresAuth: true, title: 'Заказы', bg: 'settings/setSecondaryBG' },
    feature: 'order'
  },
  {
    path: '/orders/journal',
    name: 'orders_journal',
    // component: OrdersJournal,
    component: () => import(/* webpackChunkName: "orders_journal" */ '../views/orders/OrdersJournal.vue'),
    props: route => ({ params: route.query }),
    meta: { requiresAuth: true, title: 'Журнал статусов заказов', bg: 'settings/setSecondaryBG' },
    feature: 'order.journal'
  },
  {
    path: '/orders/:id',
    name: 'order_card',
    // component: OrderCard,
    component: () => import(/* webpackChunkName: "order_card" */ '../views/orders/OrderCard.vue'),
    props: (route) => ({ id: +route.params.id, params: route.query }),
    meta: { requiresAuth: true, title: '', bg: 'settings/setSecondaryBG' },
    feature: 'order'
  },
  {
    path: '/orders_stats',
    name: 'orders_stats',
    // component: OrdersStats,
    component: () => import(/* webpackChunkName: "orders_stats" */ '../views/orders/OrdersStats.vue'),
    meta: { requiresAuth: true, title: '', bg: 'settings/setSecondaryBG' },
    feature: 'order.stats'
  },
  {
    path: '/reports',
    name: 'reports',
    // component: Reports,
    component: () => import(/* webpackChunkName: "reports" */ '../views/Reports.vue'),
    meta: { requiresAuth: true, title: '', bg: 'settings/setPrimaryBG' },
    feature: 'report'
  },
  {
    path: '/settings',
    name: 'settings',
    // component: Settings,
    component: () => import(/* webpackChunkName: "settings" */ '../views/Settings.vue'),
    meta: { requiresAuth: true, title: 'Настройки', bg: 'settings/setSecondaryBG' },
    feature: 'settings'
  },
  {
    path: '/drafts',
    name: 'drafts',
    // component: Drafts,
    component: () => import(/* webpackChunkName: "drafts" */ '../views/dev/Drafts.vue'),
    meta: { requiresAuth: true, title: 'Черновик', bg: 'settings/setPrimaryBG' },
    feature: 'draft'
  },
  {
    path: '/colors',
    name: 'colors',
    // component: ColorsSystem,
    component: () => import(/* webpackChunkName: "colors_system" */ '../views/dev/ColorsSystem.vue'),
    meta: { requiresAuth: true, title: 'Система цветов', bg: 'settings/setPrimaryBG' },
    feature: 'color'
  },
  {
    path: '/svg',
    name: 'svg',
    // component: DashboardSvg,
    component: () => import(/* webpackChunkName: "dashboard_svg" */ '../components/charts/dev/DashboardSvg.vue'),
    meta: { requiresAuth: true, title: '', bg: 'settings/setPrimaryBG' },
    feature: 'svg'
  },
  {
    path: '/help',
    name: 'help',
    component: () => import(/* webpackChunkName: "help" */ '../views/help/Help.vue'),
    meta: { requiresAuth: true, title: 'Справка', bg: 'settings/setPrimaryBG' },
    feature: 'help'
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    meta: { requiresAuth: true, bg: 'settings/setPrimaryBG' },
    feature: 'about'
  },
  {
    path: '/demo',
    name: 'demo',
    component: () => import(/* webpackChunkName: "demo" */ '../views/Demo.vue'),
    meta: { requiresAuth: true, bg: 'settings/setPrimaryBG' },
    feature: 'demo'
  },
  {
    path: '/',
    name: 'index',
    component: () => import(/* webpackChunkName: "public_index" */ '../views/Index.vue'),
    meta: { requiresAuth: false, title: '', bg: 'settings/setPrimaryBG' }
  },
  {
    path: '*',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "not found" */ '../views/NotFound.vue'),
    meta: { title: 'Страница не найдена', bg: 'settings/setPrimaryBG' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: availableRouterFeatures(routes),
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  store.dispatch('router/setRouting', true)
  document.title = store.getters['about/company'] + ' ' + store.getters['about/app'] + ' - ' + (to.meta.title ? to.meta.title : to.name)

  const loggedIn = store.getters['user/loggedIn']
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (loggedIn) {
    if (!requiresAuth) {
      next(store.getters['settings/menu/firstTopLevelItem'].route)
    } else {
      next()
    }
  } else { // not logged in
    if (requiresAuth) {
      next({ name: 'index' })
    } else {
      next()
    }
  }
})

router.afterEach((to, from) => {
  store.dispatch(to.meta.bg)
  store.dispatch('router/setRouting', false)
})

export default router
